import { render, staticRenderFns } from "./SocialNetworkAccountsHistory.vue?vue&type=template&id=f2deb65a&scoped=true"
import script from "./SocialNetworkAccountsHistory.vue?vue&type=script&lang=js"
export * from "./SocialNetworkAccountsHistory.vue?vue&type=script&lang=js"
import style0 from "./SocialNetworkAccountsHistory.vue?vue&type=style&index=0&id=f2deb65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2deb65a",
  null
  
)

export default component.exports